// import external dependencies
import 'custom-event-polyfill';
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import archive from './routes/archive';
import blog from './routes/blog';
import single from './routes/single';
import contact from './routes/contact';
import affiliatedashboard from './routes/affiliatedashboard';
import checkout from './routes/checkout';
import about from './routes/about';
import templateUpsell from './routes/upsell';
import swellUser from './routes/swell';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Product listing page
  archive,
  // Blog page
  blog,
  // Single product or blog post
  single,
  // Contact page
  affiliatedashboard,
  // Affiliate Dashboard - URL Generator page
  contact,
  // Checkout page
  checkout,
  // About page
  about,
  // Swell-specific JS
  swellUser,
  // Upsell template
  templateUpsell,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js